import { render } from "./UserActivity.vue?vue&type=template&id=1c1935ee&scoped=true"
import script from "./UserActivity.vue?vue&type=script&lang=js"
export * from "./UserActivity.vue?vue&type=script&lang=js"

import "./UserActivity.vue?vue&type=style&index=0&id=1c1935ee&scoped=true&lang=css"

import exportComponent from "/home/forge/backoffice.callmewine.co.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1935ee"]])

export default __exports__